export default "__VITE_ASSET__DCKxtkSg__"